
import { Button } from "@/components/ui/button";
import { ChevronDown } from "lucide-react";
import { BookingsTable } from "./BookingsTable";
import { DashboardStats } from "./DashboardStats";
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from "@/components/ui/collapsible";

interface BookingRecord {
  id: number;
  created_at: string;
  prompt: string;
  status: 'success' | 'failed';
  error_message?: string;
  attendee_name: string;
  scheduled_time: string;
  organizer_email: string;
  attendee_email: string;
  user_prompt: string;
}

interface BookingsSectionProps {
  bookings: BookingRecord[];
  stats: {
    total: number;
    successful: number;
    failed: number;
  };
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
}

export const BookingsSection = ({ bookings, stats, isOpen, onOpenChange }: BookingsSectionProps) => {
  return (
    <div className="space-y-4">
      <h2 className="text-2xl font-semibold">Bookings</h2>
      <DashboardStats stats={stats} />
      
      <Collapsible
        open={isOpen}
        onOpenChange={onOpenChange}
        className="w-full"
      >
        <div className="flex items-center justify-between py-2">
          <CollapsibleTrigger asChild>
            <Button variant="ghost" className="flex items-center gap-2">
              <ChevronDown className={`h-4 w-4 transition-transform duration-200 ${isOpen ? 'transform rotate-180' : ''}`} />
              {isOpen ? 'Hide' : 'Show'} Booking History
            </Button>
          </CollapsibleTrigger>
        </div>
        <CollapsibleContent className="space-y-2">
          <BookingsTable bookings={bookings} />
        </CollapsibleContent>
      </Collapsible>
    </div>
  );
};
